<template>
  <div class="contact-detail-note">
    <div class="d-flex align-center justify-space-between mb-2">
      <h4 class="text-subtitle-1 d-flex align-center">
        <v-icon start color="purple">mdi-note-text</v-icon>
        Notitie
      </h4>
      <v-btn
        icon
        variant="text"
        size="small"
        :color="disabled ? 'success' : 'error'"
        :title="disabled ? 'Notitie herstellen' : 'Notitie verwijderen'"
        @click="$emit('remove')"
      >
        <v-icon>{{ disabled ? "mdi-undo" : "mdi-delete" }}</v-icon>
      </v-btn>
    </div>

    <v-textarea
      :model-value="modelValue.note"
      label="Notitie"
      placeholder="Voer hier je notitie in..."
      variant="outlined"
      density="comfortable"
      :rules="[rules.required]"
      prepend-inner-icon="mdi-note-text"
      rows="3"
      auto-grow
      class="mb-3"
      :disabled="disabled"
      @update:model-value="updateNote"
    />

    <v-row>
      <v-col cols="8">
        <v-select
          :model-value="modelValue.note_type"
          :items="noteTypeOptions"
          label="Type notitie"
          variant="outlined"
          item-title="label"
          item-value="value"
          density="comfortable"
          :rules="[rules.required]"
          prepend-inner-icon="mdi-tag"
          class="mb-3"
          :disabled="disabled"
          @update:model-value="updateNoteType"
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          :model-value="modelValue.note_date"
          label="Datum"
          variant="outlined"
          density="comfortable"
          type="date"
          prepend-inner-icon="mdi-calendar"
          class="mb-3"
          :disabled="disabled"
          @update:model-value="updateNoteDate"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script setup>
const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:modelValue", "remove"]);

const noteTypeOptions = [
  { label: "Algemeen", value: "general" },
  { label: "Beschikbaarheid", value: "availability" },
  { label: "Rol/Functie", value: "role" },
  { label: "Voorkeur", value: "preference" },
  { label: "Belangrijk", value: "important" },
];

const rules = {
  required: (value) => !!value || "Dit veld is verplicht",
};

const updateNote = (value) => {
  emit("update:modelValue", {
    ...props.modelValue,
    note: value,
  });
};

const updateNoteType = (value) => {
  emit("update:modelValue", {
    ...props.modelValue,
    note_type: value,
  });
};

const updateNoteDate = (value) => {
  emit("update:modelValue", {
    ...props.modelValue,
    note_date: value,
  });
};
</script>

<style scoped>
.contact-detail-note {
  border-left: 3px solid rgb(var(--v-theme-purple));
  padding-left: 16px;
}
</style>
